import { render } from "./ContactBox.vue?vue&type=template&id=337d857d&scoped=true"
import script from "./ContactBox.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ContactBox.vue?vue&type=script&charset=utf-8&lang=js"

import "./ContactBox.vue?vue&type=style&index=0&id=337d857d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337d857d"]])

export default __exports__